/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
'use client';

// import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { useClickOutside } from 'hooks/useClickOutside';
// import { KF1SVGIcons } from 'kfone-component-library';
import { OfficeBuildingIcon } from 'kfone-component-library/svgIcons';
import { IHeaderProps } from 'model/interfaces';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './header.css';

export const Header: FC<IHeaderProps> = () => {
  const { t } = useTranslation();
  const [showProfileMenu, setShowProfileMenu] = useState(false);

  const dropdownRef: any = useClickOutside((handler: boolean) => {
    if (!handler) {
      setShowProfileMenu(handler);
    }
  });

  return (
    <header className='app-header fixed z-[12] w-full bg-[#ffffff]'>
      <nav
        aria-label='Global'
        className='left-0 top-0 mx-auto flex items-center justify-between px-[1.4rem] py-[0.5rem]'
      >
        <div className='flex items-center gap-x-[52px] lg:flex-1'>
          {/* <a className='-m-1.5 cursor-pointer p-1.5' onClick={() => props?.setShow(true)}>
            <Bars3CenterLeftIcon aria-hidden='true' className='h-[24px] w-[24px]' />
          </a> */}
          <span></span>
          <div className='flex items-center gap-x-4 lg:flex-1'>
            <div className='app-name text-[18px] font-semibold'>{t('pe.header.appName')}</div>
            <div className='module-name font-bold'>|</div>
            <div className='module-name text-[20px] font-semibold'>{t('pe.payEquity')}</div>
          </div>
        </div>
        <div className='flex items-center gap-x-8'>
          <div className='org-name'>
            <OfficeBuildingIcon className='h-[24px] w-[24px]' /> <span>ACME Industries (UK)</span>
          </div>
          <div ref={dropdownRef}>
            <div className='user-profile' onClick={() => setShowProfileMenu(!showProfileMenu)}>
              <img
                id='avatarButton'
                data-dropdown-toggle='userDropdown'
                data-dropdown-placement='bottom-start'
                className='size-6 h-8 w-8 cursor-pointer rounded-full'
                src='https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80'
                alt='User dropdown'
              />
              <ChevronDownIcon aria-hidden='true' className='h-[24px] w-[24px]' />
            </div>

            {showProfileMenu && (
              <div
                id='userDropdown'
                className='menu-content z-10 hidden w-44 divide-y divide-gray-100 rounded-lg bg-white shadow-lg dark:divide-gray-600 dark:bg-gray-700'
              >
                {/* <div className='px-4 py-3 text-sm text-gray-900 dark:text-white'>
              <div>Bonnie Green</div>
              <div className='truncate font-medium'>name@flowbite.com</div>
            </div> */}
                <ul
                  className='py-2 text-sm text-gray-700 dark:text-gray-200'
                  aria-labelledby='avatarButton'
                >
                  <li>
                    <a
                      href='#'
                      className='block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white'
                    >
                      {t('pe.header.yourProfile')}
                    </a>
                  </li>
                  <li>
                    <a
                      href='#'
                      className='block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white'
                    >
                      {t('pe.settings')}
                    </a>
                  </li>
                </ul>
                <div className='py-1'>
                  <a
                    href='#'
                    className='block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-600 dark:hover:text-white'
                  >
                    {t('pe.header.signOut')}
                    </a>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* </div> */}
      </nav>
    </header>
  );
};
